import { render, staticRenderFns } from "./PatientNew.vue?vue&type=template&id=3be72cf2"
import script from "./PatientNew.vue?vue&type=script&lang=js"
export * from "./PatientNew.vue?vue&type=script&lang=js"
import style0 from "./PatientNew.vue?vue&type=style&index=0&id=3be72cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports